var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNav02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Artboard_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard_1",
    "data-name": "Artboard \\u2013 1",
    clipPath: "url(#clip-Artboard_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_328",
    "data-name": "Group 328",
    transform: "translate(1672.438 -22771.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vectornav-7",
    d: "M8.5,12.625a.75.75,0,0,1-.45-.15L4.875,10.094,1.7,12.475a.75.75,0,0,1-1.2-.6V1A.75.75,0,0,1,2,1v9.375L4.425,8.556a.75.75,0,0,1,.9,0L7.75,10.375V1a.75.75,0,0,1,1.5,0V11.875a.75.75,0,0,1-.75.75Z",
    transform: "translate(-1663.75 22772.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vectornav-8",
    d: "M1,22.094a.742.742,0,0,1-.75-.73V3.641a3.294,3.294,0,0,1,.26-1.3,3.359,3.359,0,0,1,.752-1.1A3.446,3.446,0,0,1,2.391.5,3.509,3.509,0,0,1,3.707.25H19.125a.742.742,0,0,1,.75.733V18.7a.742.742,0,0,1-.75.733H3.707a1.987,1.987,0,0,0-.745.144A1.951,1.951,0,0,0,2.323,20a1.9,1.9,0,0,0-.426.625,1.868,1.868,0,0,0-.147.719v.021A.742.742,0,0,1,1,22.094ZM3.707,1.716a1.987,1.987,0,0,0-.745.144,1.951,1.951,0,0,0-.639.416A1.9,1.9,0,0,0,1.9,2.9a1.867,1.867,0,0,0-.147.737V18.563a3.514,3.514,0,0,1,1.957-.593H18.375V1.716Z",
    transform: "translate(-1670.5 22772.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vectornav",
    d: "M17.039,1.75H1A.75.75,0,1,1,1,.25H17.039a.75.75,0,0,1,0,1.5Z",
    transform: "translate(-1670.5 22793)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNav02);
export default __webpack_public_path__ + "static/media/icon-nav-02.3ce20c4f33183ccc074cfc8a6fe4dbbb.svg";
export { ForwardRef as ReactComponent };